import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const AccionActualizaHallazgoService = async (values) => {
    try {
        return await instance.Backend.post("/Hallazgo/AccionActualizaHallazgo",values, customConfig);
    } catch (error) {
        console.log(error);
    }
}
export { AccionActualizaHallazgoService };